import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { requestType } from "../../types/common";
import { Wallet } from "../../types/wallet";
interface walletType {
  wallet: requestType<Wallet>;
}
const initialState: walletType = {
  wallet: { loading: false },
};
export const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    setTaraWallet(state, action: PayloadAction<Wallet>) {
      state.wallet.loading = false;
      state.wallet.data = action.payload;
    },
    setTaraWalletLoading(state, action: PayloadAction<boolean>) {
      state.wallet.loading = action.payload;
    },
  },
});
export const walletAction = walletSlice.actions;
export default walletSlice.reducer;
